"use strict";

var formatNumber = require("./number.formatter");
var moment = require("moment-timezone");
var debug = require("debug")("knack.formatters.timer");
var _ = require("lodash");
var getTimerValue = function getTimerValue(field, value) {
  value = Number(value);

  // format as hours
  if (process && field.format && (field.format.total_format || field.format.format)) {
    var divider = 1000;
    var format = field.format.total_format || field.format.format;
    switch (format) {
      case "minutes":
        divider = 1000 * 60;
        break;
      case "hours":
        divider = 1000 * 60 * 60;
        break;
      case "days":
        divider = 1000 * 60 * 60 * 24;
        break;
      case "weeks":
        divider = 1000 * 60 * 60 * 24 * 7;
        break;
    }
    value = value / divider;
  }
  return value;
};

/**
 * @alias "formatters.timer"
 * @param {Object} timerValue
 * @param {Number} timerValue.total_time Milliseconds since Unix epoch
 * @param {Object} timerValue.times
 * @param {String} timerValue.times.to
 * @param {String} timerValue.times.to.am_pm
 * @param {String} timerValue.times.to.minutes
 * @param {String} timerValue.times.to.hours
 * @param {String} timerValue.times.to.date
 * @param {String} timerValue.times.from
 * @param {String} timerValue.times.from.am_pm
 * @param {String} timerValue.times.from.minutes
 * @param {String} timerValue.times.from.hours
 * @param {String} timerValue.times.from.date
 * @param {Object} fieldFormat
 * @param {String} fieldFormat.date_format
 * @param {String} fieldFormat.total_format Final result format, 'hours', 'seconds', 'minutes', 'days', 'weeks'
 * @param {String} [hasExportTextOption] Returns number-only value in format specified in `fieldFormat`
 * @return {String}
 */
var timerFormatter = function timerFormatter(timerValue, fieldFormat, hasExportTextOption) {
  var dateFormat = "MM/DD/YYYY hh:mm a";
  var time = "";
  if (!timerValue || timerValue.total_time === 0) {
    if (fieldFormat.date_format === "Ignore Date") {
      return "0";
    }
    if (!timerValue) {
      return "0";
    }
    time = "0";
  } else {
    // used for export
    if (hasExportTextOption === "text") {
      return getTimerValue({
        format: fieldFormat
      }, timerValue.total_time, true);
    }
    var seconds = timerValue.total_time / 1000;
    var minutes = seconds / 60;
    var hours = minutes / 60;
    var days = hours / 24;
    var weeks = days / 7;
    switch (fieldFormat.total_format) {
      case "hours":
        time = formatNumber(hours, {
          precision: 2,
          commas: true
        });
        break;
      case "seconds":
        time = formatNumber(seconds, {
          precision: 2,
          commas: true
        });
        break;
      case "minutes":
        time = formatNumber(minutes, {
          precision: 2,
          commas: true
        });
        break;
      case "days":
        time = formatNumber(days, {
          precision: 2,
          commas: true
        });
        break;
      case "weeks":
        time = formatNumber(weeks, {
          precision: 2,
          commas: true
        });
        break;
      default:
        // Floor is trimming off hours from days and minutes from hours
        // since they initially represent the entire value
        days = Math.floor(days);
        hours = Math.floor(hours);

        // minutes initially represents the entire value in minutes
        // we just want the minutes leftover from hours
        minutes = minutes % 60;
        if (hours === 0) {
          time += "".concat(minutes, " minutes");
        } else if (hours < 24) {
          if (minutes < 10) {
            minutes = "0".concat(minutes);
          }
          time += "".concat(hours, ":").concat(minutes, " hours");
        } else {
          if (minutes < 10) {
            minutes = "0".concat(minutes);
          }
          time += days;
          time += days > 1 ? " days, " : " day, ";
          time += "".concat(hours % 24, ":").concat(minutes, " hours");
        }
        break;
    }
  }
  var timer = "";
  var fromDate;
  if (timerValue.times) {
    // from
    var fromValue = Array.isArray(timerValue.times) ? timerValue.times[0].from : timerValue.times.from;
    if (fromValue.date || fromValue.hours) {
      var dateValue = fromValue.date || "";
      if (fromValue.hours) {
        if (_.isEmpty(dateValue)) {
          dateValue = "01/01/2012";
        }
        dateValue += " ".concat(fromValue.hours, ":").concat(fromValue.minutes);
        if (fromValue.am_pm) {
          dateValue += " ".concat(fromValue.am_pm.toLowerCase());
        }
      }
      try {
        fromDate = moment(dateValue, dateFormat);
      } catch (err) {
        return "";
      }
    } else {
      try {
        fromDate = moment(fromValue, dateFormat);
      } catch (err) {
        return "";
      }
    }
    var from = fromDate;

    // to
    var toValue = Array.isArray(timerValue.times) ? timerValue.times[0].to : timerValue.times.to;
    var toDate;
    if (!_.isNil(toValue.date) || !_.isNil(toValue.hours)) {
      var _dateValue = toValue.date || "";
      if (!_.isNil(toValue.hours)) {
        if (_.isEmpty(_dateValue)) {
          _dateValue = "01/01/2012";
        }
        _dateValue += " ".concat(toValue.hours, ":").concat(toValue.minutes);
        if (toValue.am_pm) {
          _dateValue += " ".concat(toValue.am_pm.toLowerCase());
        }
      }
      try {
        toDate = moment(_dateValue, dateFormat);
      } catch (err) {
        return "";
      }
    } else {
      try {
        toDate = moment(toValue, dateFormat);
      } catch (err) {
        return "";
      }
    }
    var to = toDate;

    // date and time formats
    dateFormat = "MM/DD/YY";
    switch (fieldFormat.date_format) {
      case "dd/mm/yyyy":
        dateFormat = "DD/MM/YY";
        break;
      case "M D, yyyy":
        dateFormat = "MMMM D, YY";
        break;
    }
    var timeFormat = "h:mma";
    if (fieldFormat.time_format === "HH MM (military)") {
      timeFormat = "HH:mm";
    }
    if (fieldFormat.date_format !== "Ignore Date") {
      timer += "<span>".concat(from.format(dateFormat), "</span>&nbsp;");
    }
    timer += "".concat(from.format(timeFormat), " to ");
    if (fieldFormat.date_format !== "Ignore Date" && from.format(dateFormat) !== to.format(dateFormat)) {
      timer += "<span>".concat(to.format(dateFormat), " </span>");
    }
    timer += "".concat(to.format(timeFormat), " = ");
  }
  timer += time;
  return timer;
};
module.exports = timerFormatter;